import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const highlightText = (text, searchTerm) => {
    if (!searchTerm.trim()) {
        return text;
    }
    const safeTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`(${safeTerm})`, "gi");
    const parts = text.split(regex);
    return (_jsx(_Fragment, { children: parts.map((part, idx) => regex.test(part) ? (_jsx("mark", { className: "bg-yellow-200 text-inherit p-0", children: part }, `${part}-${idx}`)) : (part)) }));
};
